import Headline from "./atoms/headline"

const Schedule = () => {
    return (
        <div id='schedule' className='section'>
            <Headline
                title={'Schedule'}
                subTitle={'スケジュール'}
            />
            {/* 画像の文字が小さいので、タップで原寸を開けるようにする */}
            <a
                className="schedule-image"
                href={process.env.PUBLIC_URL + '/images/schedule.jpg'}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={process.env.PUBLIC_URL + '/images/schedule.jpg'} alt="週間スケジュール" />
            </a>
        </div>
    )
}

export default Schedule
